// import $ from 'jquery';

export const propertySearch = ['$timeout',  function($timeout) {
    return {
        controller: 'PropertySearchController',
        scope: true,
        link: function($scope, $elem, $attrs) {

            var ac = $elem[0].getElementsByClassName('autocomplete-option');
            $elem.on('keydown', function(e){

                var key = e.keyCode ? e.keyCode : e.which;

                if (key == 38 && $scope.selected > -1) { // Up
                    $scope.selected--;
                    highlightSelected();
                }
                else if (key == 40 && $scope.selected < $scope.activeACs.length - 1) { // Down
                    $scope.selected++;
                    highlightSelected();
                }
                else if (key == 27) { // Esc
                    $scope.activeACs = [];
                    $scope.selected = -1;
                    for(var i = 0; i < ac.length; i++){
                        angular.element(ac[i]).removeClass('active');
                    }
                }
                else if (key == 13 && $scope.selected !== -1) { // Enter
                    e.preventDefault();
                    $scope.searchInput = $scope.activeACs[$scope.selected].innerText;
                    $scope.selected = -1;
                    $scope.$apply();
                    for(var i = 0; i < ac.length; i++){
                        angular.element(ac[i]).removeClass('active');
                    }
                }
                else if (key == 13){ // Enter
                    // No action - submit form
                }
                else{
                    $timeout(function(){
                        var s = $scope.searchInput;
                        $scope.activeACs = [];
                        $scope.selected = -1;
                        var myRE = RegExp(s, "i")
                        for(var i = 0; i < ac.length; i++){
                            if(typeof s === 'undefined' ||
                                s === ''){
                                angular.element(ac[i]).removeClass('active');
                            }
                            else if(ac[i].innerText.search(myRE) != -1) {
                                angular.element(ac[i]).addClass('active');
                                $scope.activeACs.push(ac[i]);
                            }
                            else{
                                angular.element(ac[i]).removeClass('active');
                            }
                        }
                        highlightSelected();
                    }, 0);
                }
            });

            function highlightSelected(){
                for(var i = 0; i < $scope.activeACs.length; i++){
                    angular.element($scope.activeACs[i]).removeClass('selected');
                }
                if($scope.selected > -1){
                    angular.element($scope.activeACs[$scope.selected]).addClass('selected');
                }
                $scope.$apply();
            }
        }
    }
}]

export const PropertySearchController = ['$scope', function($scope) {
    $scope.selected = -1;

    $scope.searchInput = '';
}]

export const SearchResults = ['$scope', '$timeout', function($scope, $timeout) {
        $scope.rooms = {};
        $scope.propsFiltered = [];
        $scope.propFilterFns = {
            bedrooms: function(prop) {
                // console.log('bedrooms');
                if ($scope.rooms.bedrooms) {
                    const br = prop.getAttribute('data-bed').split(' - ');
                    // checks for matching string values like 'studio'. or if in range like 1 - 3 if 2 is selected
                    if (br[0] ==  $scope.rooms.bedrooms || br[1] ==  $scope.rooms.bedrooms) {
                        return true
                    }
                    if (br[0] == 'Urban Flat' && br[1] >= $scope.rooms.bedrooms) {
                        return true
                    } else if (br[0] >= $scope.rooms.bedrooms && br[1] <= $scope.rooms.bedrooms) {
                        return true
                    }
                    return false
                } else {
                    return true
                }
            },
            bathrooms: function(prop) {
                // console.log('bathrooms');
                if ($scope.rooms.bathrooms) {
                    const br = prop.getAttribute('data-bath').split(' - ');
                    return br[0] ==  $scope.rooms.bathrooms || br[1] ==  $scope.rooms.bathrooms || br[0] >= $scope.rooms.bathrooms && br[1] <= $scope.rooms.bathrooms
                } else {
                    return true
                }
            },
            sqft: function(prop) {
                // console.log('sqft');
                const sqft = prop.getAttribute('data-sqft').split(' - ');
                if ($scope.sqftSlider.start[1] && $scope.sqftSlider.start[0]) {
                    return sqft[0] <= $scope.sqftSlider.start[1] && sqft[1] >= $scope.sqftSlider.start[0]
                } else {
                    return true
                }
            },
            rent: function(prop) {
                // console.log('rent');
                if ($scope.rentSlider.start[1]) {
                    return prop.getAttribute('data-rent-lo') <= $scope.rentSlider.start[1] && prop.getAttribute('data-rent-hi') >= $scope.rentSlider.start[0]
                } else {
                    return true
                }
            },
            features: function(prop) {
                // console.log('features');
                const prop_features = prop.getAttribute('data-features');
                for (const feature in $scope.featureFilter) {
                    if ($scope.featureFilter[feature] && prop_features.indexOf(feature) == -1) {
                        return false;
                    }
                }
                return true;
            },
            availability: function(prop) {
                // console.log('availability');
                if ($scope.filterDate) {
                    const prop_date = new Date(prop.getAttribute('data-avail')).getTime()
                    const filter_date = new Date($scope.filterDate).getTime()
                    return prop_date <= filter_date
                } else {
                    return true
                }
            },
        }

        $scope.propInFilteredResults = function(prop_id) {
            const inResults = $scope.propsFiltered.filter(filtered_prop => prop_id && filtered_prop.id == 'property-'+prop_id);
            return inResults.length;
        }

        $scope.sqftSlider = {
            start: [$scope.sqftMin, $scope.sqftMax],
            step: 10,
            range: {
                'min': [ $scope.sqftMin ],
                'max': [ $scope.sqftMax ]
            },
            connect: true,
            margin: 30,
        }

        $scope.rentSlider = {
            start: [$scope.rentMin, $scope.rentMax],
            step: 100,
            range: {
                'min': [ $scope.rentMin ],
                'max': [ $scope.rentMax ]
            },
            connect: true,
            margin: 100,
        }
        let timer;
        $scope.$watch('sqftSlider.start', (val) => {
            $timeout.cancel(timer);
            timer = $timeout(function() {
                $scope.filterProperties()
            }, 500);
        }, true)
        $scope.$watch('rentSlider.start', (val) => {
            $timeout.cancel(timer);
            timer = $timeout(function() {
                $scope.filterProperties()
            }, 500);
        }, true)

        $scope.filterProperties = function() {
            const properties = Array.prototype.slice.call(document.querySelectorAll(".cp-PropertyCard"));
            $scope.propsFiltered = properties.filter(function(prop) {
                // loop over filter functions and test that each returns true. If false test fails and prop is excluded from results
                for (let filter in $scope.propFilterFns) {
                    let filterFn = $scope.propFilterFns[filter];
                    if (!filterFn(prop)) {
                        return false;
                    }
                }
                return true;
            });
        }
        $scope.filterProperties();
}]


function globalSearch() {
    console.log('global search')
  var searchForms = document.querySelectorAll("[data-module=global-search]");
  if (searchForms) {
    Array.prototype.slice.call(searchForms).forEach(function (searchForm) {
      searchForm.addEventListener(
        "submit",
        function (e) {
          var searchInput = e.target.querySelector("input[name=search]");
          var options = Array.prototype.slice.apply(
            document.querySelectorAll(
              "#" + searchInput.getAttribute("list") + " option"
            )
          );
          var selectedOption = options.find(function (option) {
            return (
              option.value.toLowerCase() == searchInput.value.toLowerCase()
            );
          });
          if (selectedOption) {
            searchInput.name = selectedOption.dataset.type;
          }
          console.log(searchInput);
          // e.preventDefault()
          return true;
        },
        false
      );
    });
  }
}
globalSearch();
